import { FC } from 'react'

import { twMerge } from 'tailwind-merge'

import { Availability, Space } from '~/models/types'

type PlanDetailCardProps = Pick<
  Space,
  | 'type'
  | 'maxPeople'
  | 'name'
  | 'availability'
  | 'monthlyCostExcludingTax'
  | 'monthlyCostIncludingTax'
>

const availabilityToJaText = (availability: Availability) => {
  switch (availability) {
    case 'AVAILABLE':
      return '空きあり'
    case 'AVAILABLE_SOON':
      return '空き予定'
    case 'UNAVAILABLE':
      return '空きなし'
    default:
      return availability
  }
}

export const PlanDetailCard: FC<PlanDetailCardProps> = ({
  type,
  monthlyCostExcludingTax,
  monthlyCostIncludingTax,
  maxPeople,
  name,
  availability,
}) => {
  const isAvailableOrSoon =
    availability === 'AVAILABLE' || availability === 'AVAILABLE_SOON'

  return (
    <div className="flex flex-col overflow-hidden rounded">
      <div
        className={twMerge(
          'flex items-center justify-between px-2 py-2 font-bold text-white',
          isAvailableOrSoon ? 'bg-brand' : 'bg-[grayText]',
        )}
      >
        {type.map((t) => (
          <div
            className="shrink-0 border border-white px-1 text-xs leading-normal"
            key={t.id}
          >
            {t.name}
          </div>
        ))}
        <p className="text-[13px]">{availabilityToJaText(availability)}</p>
      </div>
      <div
        className={twMerge(
          'w-full overflow-x-scroll rounded-b border px-2 py-2',
          isAvailableOrSoon
            ? 'border-brand-light bg-brand-bg'
            : 'border-gray-border bg-grayBg',
        )}
      >
        <div className="flex w-full flex-col gap-y-3">
          <div className="text-body-s-bold leading-normal">{name}</div>

          <div className="grid grid-cols-2 items-center">
            <div className="mr-2 flex h-[49px] min-w-[114px] items-center justify-center rounded bg-white">
              {monthlyCostExcludingTax ? (
                <div className="flex flex-col items-center justify-center gap-0.5 p-1">
                  <p className="text-lg font-bold leading-none text-cta">
                    {monthlyCostExcludingTax.toLocaleString()}
                    <span className="text-xs font-normal">円/月</span>
                  </p>
                  {monthlyCostIncludingTax && (
                    <span className="text-[10px] leading-none text-grayText">
                      (税込{monthlyCostIncludingTax.toLocaleString()}円/月)
                    </span>
                  )}
                </div>
              ) : (
                <p className="text-body-bold text-cta">お問い合わせ</p>
              )}
            </div>
            <div className="flex h-[49px] min-w-[70px] items-center justify-center rounded bg-white px-2 py-1">
              <p className="text-body-bold">
                {maxPeople !== null ? (
                  <>
                    {maxPeople}
                    <span className="text-body-s font-normal">名</span>
                  </>
                ) : (
                  '-'
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
